import React from "react";

function ImovelBasicInfo(props) {
  const { imovel } = props;
  return (
    <div className="property-info mb-5" style={props.style || {}}>
      <div className="row">
        {!!(imovel.dormitórios && imovel.dormitórios !== "0") && (
          <ItemSection
            title="Dormitórios"
            value={`${(imovel.dormitórios === 1
              ? "1 Dormitório"
              : `${imovel.dormitórios} Dormitórios`) || "0 Dormitórios"}`}
            icon="fa fa-bed"
          />
        )}
        {!!(imovel.suítes && imovel.suítes !== "0") && (
          <ItemSection
            title="Suítes"
            value={`${(imovel.suítes === 1
              ? "1 Suíte"
              : `${imovel.suítes} Suítes`) || "0 Suítes"}`}
            icon="fa fa-bed"
          />
        )}
        {!!(imovel.banheiros && imovel.banheiros !== "0") && (
          <ItemSection
            title="Banheiros"
            value={`${(imovel.banheiros === 1
              ? "1 Banheiro"
              : `${imovel.banheiros} Banheiros`) || "0 Banheiros"}`}
            icon="fa fa-bath"
          />
        )}
        {!!(
          imovel.area_total ||
          imovel.area_útil ||
          imovel.area_construída ||
          imovel.area_terreno ||
          imovel.area_privativa
        ) && (
          <div className="col-md-3 col-sm-6">
            <div className="single-property-info">
              <h5>Áreas</h5>
              {!!(imovel.area_total && imovel.area_total !== "0") && (
                <p>
                  Área total {imovel.area_total}
                  {imovel.tipo_area_total || "m²"}
                </p>
              )}
              {!!(imovel.area_útil && imovel.area_útil !== "0") && (
                <p>
                  Área útil {imovel.area_útil}
                  {imovel.tipo_area_útil || "m²"}
                </p>
              )}
              {!!(imovel.area_construída && imovel.area_construída !== "0") && (
                <p>
                  Área construída {imovel.area_construída}
                  {imovel.tipo_area_construída || "m²"}
                </p>
              )}
              {!!(imovel.area_terreno && imovel.area_terreno !== "0") && (
                <p>
                  Área do terreno {imovel.area_terreno}
                  {imovel.tipo_area_terreno || "m²"}
                </p>
              )}
              {!!(imovel.area_privativa && imovel.area_privativa !== "0") && (
                <p>
                  Área privativa {imovel.area_privativa}
                  {imovel.tipo_area_privativa || "m²"}
                </p>
              )}
            </div>
          </div>
        )}
        {!!(imovel.vagas && imovel.vagas !== "0") && (
          <ItemSection
            title="Vagas"
            value={`${(imovel.vagas === 1
              ? "1 Vaga"
              : `${imovel.vagas} Vagas`) || "0 Vagas"}`}
            icon="fa fa-car"
          />
        )}
        {imovel.cidade &&
          (imovel.cidade.nome || imovel.bairro) && (
            <ItemSection
              title="Endereço"
              value={`${imovel.cidade.nome}${
                imovel.cidade.nome && imovel.bairro
                  ? `, ${imovel.bairro}`
                  : imovel.bairro
                    ? imovel.bairro
                    : ""
              }`}
              icon="fa fa-map-marker"
            />
          )}
      </div>
    </div>
  );
}
type ItemSectionProps = {
  title: string;
  icon: string;
  value: string;
};
const ItemSection = (props: ItemSectionProps) => (
  <div className="col-md-3 col-sm-6">
    <div className="single-property-info">
      <h5>{props.title}</h5>
      <p>
        <i className={props.icon} />
        {props.value}
      </p>
    </div>
  </div>
);

export default ImovelBasicInfo;
